import { XMarkIcon } from "@heroicons/react/24/solid";
import Image from "next/legacy/image";

import { RefConfig } from "../../../lib/data/ref/refConfig";
import { featureFlag } from "../../../lib/featureFlags/featureFlags";
import altaBgBl from "../../../public/img/auth-bg/alta-bg-bl.svg";
import altaBgTr from "../../../public/img/auth-bg/alta-bg-tr.svg";
import tenantConfig from "../../../tenant.config";
import { convertToName } from "../../Auth/CountryDropdown/CountryDropdown";

const bgImgStyling =
  "absolute hidden sm:block sm:w-[250px] md:w-[30vw] lg:w-[27vw] 2xl:w-[25vw] 2xl:max-w-[600px]";

export interface AuthLayoutProps {
  country: string;
  children: React.ReactNode;
  componentId?: string;
  refConfig?: RefConfig;
}

const AuthLayout: React.FC<AuthLayoutProps> = (props) => {
  const { country, children, refConfig } = props;
  const isEcfEnabled = featureFlag("ecf");

  let bgClassName = "";
  switch (country) {
    case "MY":
      bgClassName = `fixed h-screen w-screen inset-0 bg-cover bg-top bg-blend-soft-light bg-[linear-gradient(180deg,_rgba(0,0,0,0)_0%,_rgba(0,48,60,0.6)_100%),url('/img/auth-bg/malaysia-background.jpg')]`;
      break;
    case "SG":
      bgClassName = `fixed h-screen w-screen inset-0 bg-cover bg-top bg-blend-soft-light bg-[linear-gradient(180deg,_rgba(0,0,0,0)_0%,_rgba(0,48,60,0.6)_100%),url('/img/tenant/singapore-background.jpg')]`;
      break;
  }

  return (
    <div
      className={`relative flex min-h-screen w-screen grow flex-col place-items-center justify-center overflow-auto bg-brand-platform-background ${
        isEcfEnabled ? "pt-16" : "pt-12"
      }`}
    >
      <div className={bgClassName} />
      <div className="z-20 mx-auto w-full">
        <div className="grid place-items-center space-y-4">
          {refConfig?.branding ? (
            <div className="flex items-center justify-center gap-4">
              {refConfig.branding.showAltaLogo !== false && (
                <>
                  <Image
                    src="/img/tenant/white.svg"
                    alt={`${tenantConfig.entity_short_name} Auth Logo`}
                    width="100"
                    height="30"
                  />
                  {refConfig.branding.additionalLogos &&
                    refConfig.branding.additionalLogos.length > 0 && (
                      <XMarkIcon className="h-5 w-5 text-gray-400" />
                    )}
                </>
              )}
              {refConfig.branding.additionalLogos?.map((logo, index) => (
                <Image
                  key={index}
                  src={logo.logoPath}
                  alt={logo.alt}
                  width={logo.width || 100}
                  height={logo.height || 30}
                />
              ))}
            </div>
          ) : (
            <Image
              src="/img/tenant/white.svg"
              alt={`${tenantConfig.entity_short_name} Auth Logo`}
              width="250"
              height="30"
            />
          )}
          {isEcfEnabled && !refConfig?.skipECF && (
            <div
              id={
                props.componentId + "-header-country-" + convertToName(country)
              }
              className="w-32 rounded-tl-xl rounded-br-xl bg-[#40C1AC] px-4 py-1 text-center text-xs uppercase tracking-[0.28em] text-white"
            >
              {convertToName(country)}
            </div>
          )}
          <div className="fp-auth-layout pb-12 pt-4 md:max-w-xl">
            {children}
          </div>
        </div>
        {tenantConfig.services["a-prime"].showOverlaysOnAPrimeAuthPage && (
          <img
            src={altaBgBl.src}
            alt=""
            className={`bottom-0 left-0 ${bgImgStyling}`}
          />
        )}
        {tenantConfig.services["a-prime"].showOverlaysOnAPrimeAuthPage && (
          <img
            src={altaBgTr.src}
            alt=""
            className={`top-0 right-0 ${bgImgStyling}`}
          />
        )}
      </div>
    </div>
  );
};
export default AuthLayout;
